import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { refreshQueueOnCacheMiss } from '../../lib/refreshQueue';
import setQueueStatus from './setQueueStatus';
import { removeSessionFromQueue } from './queueSessionUtils';
import { enqueueQueueSessionDeltaEvent } from '../../lib/coalesceWorkspaceEvents';

function applyQueueSessionLeft(
  event: Telecom.QueueSessionLeftEvent,
): void | Promise<void> {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:session_left:' + queue?.name, event);

  if (!queue) {
    return refreshQueueOnCacheMiss(event.queueId);
  }

  removeSessionFromQueue({
    queue,
    event,
    logPrefix: 'rtcs:queue:session_left',
    handlerName: 'handleQueueSessionLeft',
  });
  setQueueStatus(queue, event);
}

function handleQueueSessionLeft(event: Telecom.QueueSessionLeftEvent) {
  return enqueueQueueSessionDeltaEvent(event.queueId, () =>
    applyQueueSessionLeft(event),
  );
}

export default handleQueueSessionLeft;
